export default "__VITE_ASSET__DaD90K96__"